import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  ctaMovie: {
    id: 'seo_blue_beetle_communicate_cta_1',
  },
  ctaCinema: {
    id: 'seo_blue_beetle_communicate_cta_2',
  },
  label: {
    id: `seo_blue_beetle_mission_label`,
  },
  titleCinema: {
    id: 'seo_blue_beetle_communicate_cta_header',
  },
  titleMovie: {
    id: 'seo_blue_beetle_communicate_cta_1_header',
  },
});
